"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberProperty = void 0;
const property_factory_1 = require("./property-factory");
exports.numberProperty = (0, property_factory_1.propertyFactory)((stringValue) => {
    const value = +stringValue;
    if (isNaN(value)) {
        throw new Error('Must be a number');
    }
    return value;
});
//# sourceMappingURL=number-property.js.map